import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Col,
  Grid,
  Row,
  ControlLabel,
} from 'react-bootstrap';

import { selectPayPeriod } from '../actions';
import { withAllPayPeriods } from '../graphql/PayPeriodQueries';
import omitProps from '../../../utils/omitProps';
import queryMetaHandler from '../../../utils/queryMetaHandler';

const propTypes = exact({
  payPeriods: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
});

const PayPeriodSelector = (props) => {
  return (
    <Grid fluid>
      <Row>
        <ControlLabel className="pull-left control-label">Pay Period:</ControlLabel>
        <Col xs={2}>
          <DropdownList
            data={props.payPeriods}
            textField="range_display"
            valueField="id"
            defaultValue={props.payPeriods[0]}
            onChange={(value) => { props.onSelect(value); }}
          />
        </Col>
      </Row>
    </Grid>
  );
};

PayPeriodSelector.propTypes = propTypes;

const mapDispatchToProps = {
  onSelect: selectPayPeriod,
};

const withRedux = connect(null, mapDispatchToProps);

const withSelectFirstPayPeriod = lifecycle({
  componentWillMount() {
    const { onSelect, payPeriods } = this.props;
    if (payPeriods.length > 0) {
      onSelect(payPeriods[0]);
    }
  },
});

const enhance = compose(
  withRedux,
  withAllPayPeriods,
  queryMetaHandler,
  omitProps(['data']),
  withSelectFirstPayPeriod,
);

export default enhance(PayPeriodSelector);
